
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import sved from "../../assets/sved.png";


function SvedMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Svéd magyar fordító</title>
                <meta name='description' content="Ingyenes svéd magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Svéd magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/sved-magyar-fordito" />
            </Helmet>
            <h1>Svéd magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A svéd nyelvről</h2>
                    <img src={sved} alt="Svéd zászló"></img>
                </div>

                <p>A svéd vagy svenska egy észak-germán nyelv, amelyet elsősorban Svédországban beszélnek. Finnország egyik hivatalos nyelveként is elismert, és más országok svéd ajkú közösségei is beszélik, például Norvégiában és Észtországban. A svéd dallamos hangzásáról, nyelvtani egyszerűségéről és más skandináv nyelvekre gyakorolt hatásáról ismert.</p>

                <p>A svéd írásrendszer a latin ábécét használja három további karakterrel: å, ä és ö. 29 betűből áll. A svéd kiejtés általában egyszerű, minden betűnek egységes hangja van. Vannak azonban eltérések a regionális akcentusokban és nyelvjárásokban.</p>

                <p>A svéd nyelvtan főnévi ragozásokat, igeragozásokat és nyelvtani nemeket tartalmaz. A főnevek és melléknevek nem és szám alapján változtatják alakjukat, két nem (közös és semleges) és két szám (egyes és többes szám). Az igék ragozása idő, mód és személy szerint történik.</p>

                <p>A svéd szókincsnek germán gyökerei vannak, de más nyelvekből, különösen az angolból származó kölcsönszavakat is tartalmaz. A svéd irodalom gazdag hagyományokkal rendelkezik, olyan befolyásos szerzőkkel, mint August Strindberg és Astrid Lindgren. A svéd kultúrát az egyenlőségre, a társadalmi jólétre és a környezeti fenntarthatóságra helyezett hangsúly jellemzi.</p>

                <p>A svéd nyelvtudás számos lehetőséget kínál. Svédország erős gazdasággal rendelkezik, különösen az olyan ágazatokban, mint a technológia, és a tervezés. A svéd nyelv ismerete előnyös lehet ezeken a területeken, vagy azoknak, akik szeretnének tanulni vagy dolgozni Svédországban.</p>

                <p>A svéd nyelvet más skandináv országokban és közösségekben is beszélik, ami elősegíti a kapcsolatokat és megkönnyíti a kommunikációt a régión belül. A svéd nyelv ismerete hozzáférést biztosít a svéd nyelvű médiához, irodalomhoz és kulturális eseményekhez.</p>

                <p>Ezenkívül a svéd nyelv tanulása ajtókat nyit Svédország kulturális örökségéhez és hagyományaihoz. Lehetővé teszi a svéd társadalom, szokások és értékek mélyebb megértését. A svéd konyha, a zene és a design nemzetközi elismerést és elismerést vívott ki magának.</p>
           
           
            </section>
        </>

    )
}

export default SvedMagyar;